(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gallery-notification"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gallery-notification')) {
    customElements.define(
      'gallery-notification',
      class GalleryNotification extends HTMLElement {
        connectedCallback() {
          this.nodes = [];
          this.timers = new Map();

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
          } else {
            this.init();
          }

          // The theme swaps in a fresh <media-gallery> on variant change (media-gallery.js
          // replaceWith), which drops the injected node. Re-inject when a new gallery lands.
          const section = this.closest('.shopify-section');
          if (section) {
            this.mo = new MutationObserver((mutations) => {
              const galleryAdded = mutations.some((m) =>
                [...m.addedNodes].some((n) => n instanceof Element && (n.matches('media-gallery') || n.querySelector('media-gallery')))
              );
              if (!galleryAdded) return;
              this.teardown();
              this.init();
            });
            this.mo.observe(section, { childList: true, subtree: true });
          }
        }

        init() {
          const tpl = this.querySelector('template');
          if (!tpl) return;

          const scope = this.closest('.shopify-section') || document;
          const target = parseInt(this.dataset.target, 10) || 2;
          this.delay = parseInt(this.dataset.delay, 10) || 0;
          this.hold = parseInt(this.dataset.hold, 10) || 0;
          this.replay = this.dataset.replay === 'true';

          scope.querySelectorAll(this.dataset.gallerySelector).forEach((gallery) => {
            if (gallery.closest('dialog')) return; // skip zoom / lightbox copies

            const slides = gallery.querySelectorAll(this.dataset.slideSelector);
            const slide = slides[target - 1];
            if (!slide || slide.querySelector(':scope > .gn')) return;

            const node = tpl.content.firstElementChild.cloneNode(true);
            slide.classList.add('gn-host');
            slide.appendChild(node);
            this.nodes.push(node);
          });

          if (!this.nodes.length) {
            console.warn('[gallery-notification] Target slide not found. Check gallery/slide selectors.');
            return;
          }

          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const node = entry.target.querySelector(':scope > .gn');
                if (!node) return;
                entry.isIntersecting ? this.show(node) : this.reset(node);
              });
            },
            { threshold: 0.6 }
          );

          this.nodes.forEach((node) => this.io.observe(node.parentElement));
        }

        show(node) {
          if (node.dataset.shown && !this.replay) return;
          this.clear(node);

          const showTimer = setTimeout(() => {
            node.classList.add('is-visible');
            node.dataset.shown = '1';

            if (this.hold > 0) {
              const hideTimer = setTimeout(() => node.classList.remove('is-visible'), this.hold);
              this.timers.set(node, hideTimer);
            }
          }, this.delay);

          this.timers.set(node, showTimer);
        }

        reset(node) {
          this.clear(node);
          if (this.replay) node.classList.remove('is-visible');
        }

        clear(node) {
          clearTimeout(this.timers.get(node));
          this.timers.delete(node);
        }

        teardown() {
          this.io?.disconnect();
          this.nodes?.forEach((node) => {
            this.clear(node);
            node.parentElement?.classList.remove('gn-host');
            node.remove();
          });
          this.nodes = [];
        }

        disconnectedCallback() {
          this.mo?.disconnect();
          this.teardown();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
